import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PaymentStepsService } from '../../../services/payment-steps.service';
import { PaymentPaymentOption } from '../payment.payment.option';

@Component({
    selector: 'payment-payment-option-card',
    templateUrl: './payment.payment.option.card.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentPaymentOptionCardComponent extends PaymentPaymentOption implements OnInit {
    public filledFlag = false;
    public loading = false;
    public cardsCount: Array<number> = [1];
    public validCardsCount: Array<number> = [];
    @Input() index;
    @Input() deliverable: boolean;
    @Input() total: number;
    @Input() amountDifference: number;
    @Output() filled: EventEmitter<null> = new EventEmitter();
    @Output() unfilled: EventEmitter<null> = new EventEmitter();
    @Output() amountChanged: EventEmitter<number> = new EventEmitter();

    constructor(
        protected paymentStepsService: PaymentStepsService
    ) {
        super();
    }

    ngOnInit() {
        this.paymentStepsService
            .loadConfigurations(this.paymentMethod.payment_gateway_tenant)
            .subscribe();
    }

    public updateAmountDifference(amount) {
        this.amountChanged.emit(amount);
    }

    /**
     * Increments cards count items.
     **/
    public incrementsCardsCount() {
        this.cardsCount.push(this.cardsCount.length + 1);
    }
    /**
     * submitted event listener.
     **/
    public onSubmitted(): void {
    }
    /**
     * findingZipCode event listener.
     **/
    public onFindingZipCode(zipCode) {
        this.loading = true;
    }
    /**
     * foundZipCode event listener.
     **/
    public onFoundZipCode(zipCode) {
        this.loading = false;
    }
    /**
     * notFoundZipCode event listener.
     **/
    public onNotFoundZipCode(zipCode) {
        this.loading = false;
    }
    /**
     * Verify if all cards was filled and then trigger filled event.
     **/
    public onFilled(cardIndex) {
        if (this.validCardsCount.indexOf(cardIndex) === -1) {
            this.validCardsCount.push(cardIndex);
        }
        if (this.validCardsCount.length === this.cardsCount.length) {
            this.filledFlag = true;
            this.filled.emit(null);
        } else {
            this.filledFlag = false;
            this.unfilled.emit(null);
        }
    }
    /**
     * Verify if all cards was filled and then trigger filled event.
     **/
    public onUnfilled(cardIndex) {
        let index = this.validCardsCount.indexOf(cardIndex);
        if (index > -1) {
            this.validCardsCount.splice(index, 1);
        }
        this.filledFlag = false;
        this.unfilled.emit(null);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/payment/option/card/payment.payment.option.card.component.ts